// import external dependencies

/* eslint-disable */
import "slick-carousel"
import "rangeslider.js"
import "./modules/jquery.maskMoney";
// import {onINP} from 'web-vitals/attribution';
/* eslint-enable */

var DESKTOP_WIDTH = 1250;
var floatingNav = $('.floating-nav');
var modal = document.getElementById("credit-modal");
// var $body = $('body');
// var $html = $('html');
$('header').addClass('scrolled');
$('.form-entry-text-span').hide();
$('.form-title-success').hide();
$('.form-title-placed').hide();
$('.form-title-error').hide();
$('#terms-error').hide();
$('#name-error').hide();
$('#amount-error').hide();
$('#time-error').hide();
$('#email-error').hide();
$('#phone-error').hide();
$('#age-error').hide();
$('#payments-error').hide();
$('#income-error').hide();
$('#residence-error').hide();
$('.form-entry-text-success').hide();
$('.form-entry-text-placed').hide();
$('.form-entry-text-error').hide();
$('.form-title-payments-error').hide();
$('.form-title-residence-error').hide();
$('.form-entry-text-payment-text-error').hide();
$('.form-entry-text-residence-text-error').hide();
$('.form-title-payment-value-error').hide();
$('.form-entry-text-payment-value-text-error').hide();
$('.informationBank').show();
$('#progress-bar').hide();
$('.errorSVG').hide();
$('.outputValueHome').val($('input[type="range"].formatNumber').val());
$('input[type="range"].formatNumber').addClass('cp_rangeSlider');

// function sendToGoogleAnalytics ({name, value, id, attribution}) {
// 	// Destructure the attribution object:
// 	const {eventEntry, eventTarget, eventType, loadState} = attribution;
//
// 	// Get timings from the event timing entry:
// 	const {startTime, processingStart, processingEnd, duration, interactionId} = eventEntry;
//
// 	const eventParams = {
// 		// The page's INP value:
// 		metric_inp_value: value,
// 		// A unique ID for the page session, which is useful
// 		// for computing totals when you group by the ID.
// 		metric_id: id,
// 		// The event target (a CSS selector string pointing
// 		// to the element responsible for the interaction):
// 		metric_inp_event_target: eventTarget,
// 		// The type of event that triggered the interaction:
// 		metric_inp_event_type: eventType,
// 		// Whether the page was loaded when the interaction
// 		// took place. Useful for identifying startup versus
// 		// post-load interactions:
// 		metric_inp_load_state: loadState,
// 		// The time (in milliseconds) after page load when
// 		// the interaction took place:
// 		metric_inp_start_time: startTime,
// 		// When processing of the event callbacks in the
// 		// interaction started to run:
// 		metric_inp_processing_start: processingStart,
// 		// When processing of the event callbacks in the
// 		// interaction finished:
// 		metric_inp_processing_end: processingEnd,
// 		// The total duration of the interaction. Note: this
// 		// value is rounded to 8 milliseconds of granularity:
// 		metric_inp_duration: duration,
// 		// The interaction ID assigned to the interaction by
// 		// the Event Timing API. This could be useful in cases
// 		// where you might want to aggregate related events:
// 		metric_inp_interaction_id: interactionId,
// 	};
//
// 	// Send to Google Analytics
// 	// eslint-disable-next-line
// 	gtag('event', name, eventParams);
// }

// Pass the reporting function to the web-vitals INP reporter:
// onINP(sendToGoogleAnalytics);

window.sliderManualUpdate = false;

jQuery(document).ready(($) => {

	// Passive event listeners
	jQuery.event.special.touchstart = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
		},
	};
	jQuery.event.special.touchmove = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
		},
	};

	window.selected_credit_type = '';
	$('.ask-credit').on('click', function (event) {

		$('#credit-modal').removeClass('last-opened-with-sticky-cta');
		$('.simulador-popup-geral').removeClass('last-opened-with-sticky-cta');
		//Se foi através do sticky, insere a class
		if($(this).hasClass('sc-button') || $(this).hasClass('credit-button')) {
			$('#credit-modal').addClass('last-opened-with-sticky-cta');
			$('.simulador-popup-geral').addClass('last-opened-with-sticky-cta');
		}


		//Se for click em mini cta dá prioridade a tudo
		if($(this).hasClass('mini-cta-button-overwrite') || $(this).hasClass('cta-button-overwrite') || $(this).hasClass('summary-cta-button-overwrite')) {
			if($(this).hasClass('open-popup-general-form')) {
				$('.popup-form-main-container-outter').addClass('in');
				$('.simulador-popup-geral').addClass('in');
				jQuery('.simulador-popup-geral input[type="range"]').rangeslider('update', true);
				var ofertaInicial = jQuery(this).attr('data-ofertainicial');
				jQuery('.simulador-popup-geral label[for="popup-geral-credit-type'+ofertaInicial+'"]').trigger('click');
				//Finalidade Inicial
				var finalidadeInicial = jQuery(this).attr('data-finalidadeinicial');
				jQuery('.simulador-popup-geral .select-options li[data-rel="'+finalidadeInicial+'"][data-creditid="'+ofertaInicial+'"]').trigger('click');
				$('body').addClass('disable-scroll');
				return;
			}
		} else {
			var isLandingPage = $('.simulador-popup-geral .is_landing_page').attr('data') == 'yes';

			if(isLandingPage) {
				var simulador_a_usar_em_toda_a_landing_page_modal = $('.simulador-popup-geral .simulador_a_usar_em_toda_a_landing_page_modal').attr('data');

				if(simulador_a_usar_em_toda_a_landing_page_modal == 'offers-simulator') {
					$('.popup-form-main-container-outter').addClass('in');
					$('.simulador-popup-geral').addClass('in');
					jQuery('.simulador-popup-geral input[type="range"]').rangeslider('update', true);
					$('body').addClass('disable-scroll');
					return;
				}
			}

			//Open popup general form
			if(!isLandingPage && $(this).hasClass('open-popup-general-form')) {

				$('.popup-form-main-container-outter').addClass('in');
				$('.simulador-popup-geral').addClass('in');
				jQuery('.simulador-popup-geral input[type="range"]').rangeslider('update', true);

				//Se for o sticky CTA
				if($(this).hasClass('sc-button') || $(this).hasClass('credit-button')) {
					var ofertaInicialSticky = jQuery(this).attr('data-ofertainicial');
					jQuery('.simulador-popup-geral label[for="popup-geral-credit-type'+ofertaInicialSticky+'"]').trigger('click');
					//Finalidade Inicial
					var finalidadeInicialSticky = jQuery(this).attr('data-finalidadeinicial');
					jQuery('.simulador-popup-geral .select-options li[data-rel="'+finalidadeInicialSticky+'"][data-creditid="'+ofertaInicialSticky+'"]').trigger('click');
				}
				$('body').addClass('disable-scroll');
				return;
			}

			if(!isLandingPage) {
				var ativar_popup_form_em_todo_o_site = $('.simulador-popup-geral .ativar_popup_form_em_todo_o_site').attr('data');
				if(ativar_popup_form_em_todo_o_site == 'yes') {
					$('.popup-form-main-container-outter').addClass('in');
					$('.simulador-popup-geral').addClass('in');
					jQuery('.simulador-popup-geral input[type="range"]').rangeslider('update', true);
					$('body').addClass('disable-scroll');
					return;
				}
			}

			if(!isLandingPage) {
				var overwrite_simulador_modal = $('.simulador-popup-geral .overwrite_simulador_modal').attr('data');

				if(!$(this).hasClass('sc-button') && !$(this).hasClass('credit-button')) {
					if(overwrite_simulador_modal == 'offers-simulator') {
						$('.popup-form-main-container-outter').addClass('in');
						$('.simulador-popup-geral').addClass('in');
						jQuery('.simulador-popup-geral input[type="range"]').rangeslider('update', true);
						$('body').addClass('disable-scroll');
						return;
					}
				}
			}
		}












		//End of select cc or cp form, it leaves the function
		$("#phone").attr("maxlength", 9);
		event.preventDefault();
		modal.style.display = "block";
		// $html.css('overflow', 'hidden');
		// $body.css('overflow', 'hidden');
		$('body').addClass('noscroll');
		var attr = $(this).attr('data-id');
		if (typeof attr !== typeof undefined && attr !== false) {
			$('#amount').val($('.outputValueHome').val().replace(/[^0-9]/g,''));
			$('.userAmount').val($('.outputValueHome').val().replace(/[^0-9]/g,'')).change();
		}
		if(attr !== 'homepage') {
			$('.options-holder.active').click();
			window.selected_credit_type = $('.options-holder.active').data('name');
		}
		// $('')
	});

	if ($('.companies-promo__list').length) {
		if (window.location.href.indexOf('creditoconsolidado') == -1) {
			$('.companies-promo__list').slick({
				slidesToSwipe: 1,
				mobileFirst: true,
				infinite: false,
				variableWidth: true,
				arrows: false,
				swipeToSlide: true,
				responsive: [{
					breakpoint: 768,
					settings: "unslick",
				}],
			});
		}
	}

	/**
	 * @desc activate rangeslider
	 */
	/* eslint-disable */
	const $document = $(document);
	const selector = '.range-slider input';
	const $element = $(selector);
	// For ie8 support
	let textContent = ('textContent' in document) ? 'textContent' : 'innerText';
	var sliders_map = {};

	function toArray(obj) {
		var array = [];
		// iterate backwards ensuring that length is an UInt32
		for (var i = obj.length >>> 0; i--;) {
			array[i] = obj[i];
		}
		return array;
	}

	$('.value-element .range-slider__output').maskMoney({ precision: 0, suffix: ' €', thousands: ' ', selectAllOnFocus: true }).maskMoney('mask');
	$('.time-element .range-slider__output').maskMoney({ precision: 0, suffix: ' Meses', thousands: '', allowNegative: false, selectAllOnFocus: true }).maskMoney('mask');

	function valueOutput(element, round = false) {
		// console.log('asdasd2323');
		let value = element.value;
		let output = element.parentNode.getElementsByClassName('range-slider__output')[0] || element.parentNode.parentNode.getElementsByClassName('range-slider__output')[0];
		let classList = toArray(element.classList);

		if(round) {
			if( element.classList.contains('cc_debt_amount-v2') || element.classList.contains('cc_housing_debt_amount-v2') || element.classList.contains('cc_valor_adicional-v2') || element.classList.contains('debt_amount') ) {
				value = roundToNearest500(parseInt(value));
			}
			if(element.classList.contains('cc_monthly_payment-v2') || element.classList.contains('cc_housing_monthly_payment-v2')) {
				value = roundToNearest10(parseInt(value));
			}
		}

		value = (classList.includes("formatNumber")) ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : value; // If it's a currency, format it.
		output.value = value;
		$('.range-slider__output').maskMoney('mask');
	}

	function roundToNearest500(value) {
		return Math.round(value / 500) * 500;
	}

	function roundToNearest10(value) {
		return Math.round(value / 10) * 10;
	}

	// $document.on('input', 'input[type="range"], ' + selector, function (e) {
	// 	valueOutput(e.target);
	// });

	// Basic rangeslider initialization
	$element.rangeslider({
		// Deactivate the feature detection
		polyfill: false,
		rangeslider: 'rangeslider',
		disabledClass: 'rangeslider--disabled',
		horizontalClass: 'rangeslider--horizontal',
		verticalClass: 'rangeslider--vertical',
		fillClass: 'rangeslider__fill',
		handleClass: 'rangeslider__handle',

		// Callback function
		onInit: function () {
			valueOutput(this.$element[0]);

			// if ($(this.$element[0]).parent().parent().parent().parent().attr('id')) {
			// 	sliders_map[$(this.$element[0]).parent().find('span').text()] = false;
			// }
		},
		onSlide: function(position, value) {
			// console.log('onSlide');
			// if ($(this.$element[0]).parent().find('span').text() in sliders_map) {
			// 	sliders_map[$(this.$element[0]).parent().find('span').text()] = true;
			// }
			// console.log(this.$element[0]);
			// console.log(value);
			// valueOutput($(this.$element[0]), true);
			// console.log(this.$element[0]);
			if (!window.sliderManualUpdate) { // Use the global variable
				valueOutput(this.$element[0], true);
			}
		},
		onSlideEnd: function(position, value) {
			// console.log('onSlideEnd');
			valueOutput(this.$element[0], true);
			// console.log('slideend');
			// console.log(value);
			// valueOutput($(this.$element[0]), true);
		},
	});
	/* eslint-enable */
	const myCheck = $('#bad_post');
	if (myCheck.length) {
		$('#commentform button').click(function (e) {
			var sliders = $('#commentform .range-slider');
			var i = 0;
			var n = 0;
			sliders.each(function() {
				$(this).find('span').css('color', '');
				if (sliders_map[$(this).find('span').text()]) {
					i++;
				}
				n++;
			});

			if (i != n) {
				e.preventDefault();
				sliders.each(function() {
					var _this = $(this);
					if (!sliders_map[$(this).find('span').text()]) {
						_this.find('span').css('color', 'red');
						setTimeout(function () {
							_this.find('span').css('color', '');
						}, 2000);
					}
				});
			}
			if (myCheck.prop('checked')) {
				return true;
			} else {
				e.preventDefault();
				$('.checkbox__label').addClass('checkbox__label_error');
				setTimeout(function () {
					$('.checkbox__label').removeClass('checkbox__label_error');
				}, 2000);
			}
		})
	}

	if (floatingNav.length) {
		setActiveStickyNavLink(floatingNav);
	}
	generateSideNavLinks(floatingNav);

	if($('.options-holder.active').length < 1)$('.options-holder').eq(0).addClass('active');

	const eventLLS = new Event('lazyLoadScripts');
	var app = {
		init: function() {
			window.addEventListener("scroll", function() {
				if (window.__he == undefined) {
					app.load();
				}
			});
			window.addEventListener("mousemove", function() {
				if (window.__he == undefined) {
					app.load();
				}
			});
		},
		load: function() {
			window["__he"] = true;
			setTimeout(function (){
				window.dispatchEvent(eventLLS);
				console.log('Lazyload Scripts triggered')
			}, 500);
		},
	};

	window.addEventListener('lazyLoadScripts', function () {
		var jsScript = document.createElement('script');
		jsScript.src = '/wp-content/themes/credito-rapido/dist/scripts/defered.js?ver=1.3.47';
		document.body.appendChild(jsScript);
		// var ccSimulatorV2Script = document.createElement('script');
		// ccSimulatorV2Script.src = '/wp-content/themes/credito-rapido/template-parts/block/simulador-credito-consolidado-v2/script.js?ver=2.3';
		// document.body.appendChild(ccSimulatorV2Script);

		// var trustElementsJs = document.createElement('script');
		// trustElementsJs.src = '/wp-content/themes/credito-rapido/template-parts/block/trust-elements/script.js?ver=2.3';
		// document.body.appendChild(trustElementsJs);
		//
		// var financialCompaniesListJs = document.createElement('script');
		// financialCompaniesListJs.src = '/wp-content/themes/credito-rapido/template-parts/block/financial-companies-list/script.js?ver=2.3';
		// document.body.appendChild(financialCompaniesListJs);

		jsScript = document.createElement('script');
		jsScript.src = '/wp-content/themes/credito-rapido/assets/scripts/modal-form-validate.js?v=1.1';
		document.body.appendChild(jsScript);
	}, false);
	app.init();

});

function generateSideNavLinks(floatingNav) {
	let headers = '';

	headers = $('.content-to-navigate h2, .content-to-navigate h3');

	if (headers.length) {
		headers.each(
			function () {
				let boxTitle = $(this).data('nav-heading'),
					boxLink = $(this).attr('id'),
					boxSize = ($(this).attr('data-size') == 'h3') ? 'toc-sub-item' : '';



				if (!boxLink) {
					let boxContainer = $(this).parent().parent().parent();
					boxLink = boxContainer.attr('id');
				}
				if (!boxLink) {
					let boxContainer = $(this).parents('.rating-box');
					boxLink = boxContainer.attr('id');
				}

				if (boxLink && boxTitle) {
					// boxLink = boxLink.replace(/[^a-zA-Z ]/g, "");
					boxLink = boxLink.replace('é', 'e').replace('ç', 'c').replace('ã', 'a').replace('õ', 'o').replace('á', 'a').replace('à', 'a').replace('ê', 'e').replace('ó', 'o').replace('í', 'i').toLowerCase();
					if ($("body").hasClass("cp")) {
						floatingNav.find('.generated-nav').append('<li class="' + boxSize + '" data-link="' + boxLink + '"><a class="" href="#' + boxLink + '">' + boxTitle + '</a></li>');
					}else{
						var svg = window.location.href.indexOf('creditoconsolidado') > -1 ? '<svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.88886 0.337061C1.21776 0.117298 1.60444 0 2 0C2.53043 0 3.03914 0.210714 3.41421 0.585787C3.78929 0.960859 4 1.46957 4 2C4 2.39556 3.8827 2.78224 3.66294 3.11114C3.44318 3.44004 3.13082 3.69638 2.76537 3.84776C2.39992 3.99913 1.99778 4.03874 1.60982 3.96157C1.22186 3.8844 0.865493 3.69392 0.585788 3.41421C0.306083 3.13451 0.115601 2.77814 0.0384303 2.39018C-0.0387401 2.00222 0.000866562 1.60008 0.152242 1.23463C0.303617 0.86918 0.559961 0.556824 0.88886 0.337061Z" fill="#2E3192"/></svg>' : '<svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35336 0.646484L9.76758 2.0607L5.06047 6.7678L0.353365 2.0607L1.76758 0.646484L5.06047 3.93938L8.35336 0.646484Z"/></svg>';

						floatingNav.find('.generated-nav').append('<li class="' + boxSize + '" data-link="' + boxLink + '">' + svg + '<a class="" href="#' + boxLink + '">' + boxTitle + '</a></li>');
					}
				}
			}
		)
	} else {
		floatingNav.find('.generated-nav').hide();
	}
}

function setActiveStickyNavLink(floatingNav) {
	let casinoNavigation = floatingNav.find('.generated-nav').find('li'),
		casinoNavigationN = casinoNavigation.length,
		scrollPosition = window.scrollY;
	if (casinoNavigationN) {
		let hasActive = 0;
		let pBarHeight = $('#progress-bar').outerHeight(),
			sNavHeight = $('.sliding-nav').outerHeight(),
			headerHeight = $('header').outerHeight();
		if ($(window).width() < DESKTOP_WIDTH) {
			sNavHeight = $('.sliding-nav.active').outerHeight();
		} else {
			sNavHeight = 0;
		}
		let fixedblocksHeight = pBarHeight + sNavHeight + headerHeight;
		for (let i = 0; i < casinoNavigationN; i++) {
			let boxToCheck = $('#' + casinoNavigation.eq(i).data('link'));
			let boxPosition = boxToCheck.offset().top;
			if ((scrollPosition - boxPosition + fixedblocksHeight) >= -1) {
				hasActive = 1;
				casinoNavigation.eq(i).addClass('active');
				if (i) {
					casinoNavigation.eq(i - 1).removeClass('active');
				}
			} else {
				casinoNavigation.eq(i).removeClass('active');
			}
		}
		if (!hasActive) {
			casinoNavigation.eq(0).addClass('active');
		}
	}
}

// $('.footer-info-menu.mobile-only li:nth-of-type(3)').addClass('intermediacao-url');

var windowWidthX = $(window).width();

if(windowWidthX < 768) {
	$('.extra-fake-menu-item').insertAfter('ul#footer-menu > li:last-of-type');
} else if(windowWidthX >= 768 && windowWidthX < 1250) {
	$('.extra-fake-menu-item').insertAfter('ul#footer-menu > li:last-of-type ul');
}

$(window).on('resize', function() {


	var windowWidth = $(window).width();

	// console.log(windowWidth);
	// console.log($('ul#footer-menu > li:last-child ul'));

	if(windowWidth < 768) {
		$('.extra-fake-menu-item').insertAfter('ul#footer-menu > li:last-of-type');
	} else if(windowWidth >= 768 && windowWidth < (1250 - 15)) {
		$('.extra-fake-menu-item').insertAfter('ul#footer-menu > li:last-of-type ul');
	} else if(windowWidth >= (1250 - 15)) {
		$('.extra-fake-menu-item').insertAfter('.footer-parent-desktop');
	}



});

$('ul#footer-menu li>a').removeClass('submenu-collapse-action');

var initialTop = $('.header').position().top;
window.addEventListener('scroll', function() {
	var windowTop = $(window).scrollTop(); // Get the top scroll position of the window
	var newTop = initialTop - windowTop;
	if(newTop < 0) {
		$('.header').css('top', '0px');
		return;
	}
	// console.log(newTop);
	$('.header').css('top', newTop + 'px');
});

var slidingNavStickonInitialTop = 88;
if($(window).width() > 767) {
	slidingNavStickonInitialTop = 104;
}
window.addEventListener('scroll', function() {
	var windowTop = $(window).scrollTop(); // Get the top scroll position of the window
	var newTop = slidingNavStickonInitialTop - windowTop;
	if($(window).width() > 767) {
		if(newTop < 88) {
			$('.sliding-nav.stickon').css('top', '88px');
			return;
		}
	}
	if(newTop < 64) {
		$('.sliding-nav.stickon').css('top', '64px');
		return;
	}
	$('.sliding-nav.stickon').css('top', newTop + 'px');
});

jQuery('button.header-client-area-button').on('click', function(e) {
	e.preventDefault();
	window.location.href= "https://client.gestlifes.com/";
});



// WEBPACK FOOTER //
// ./scripts/main.js